<template>
    <div class="container-menu">
    <Menu as="div">
      <MenuButton>Cambiar N° Registros</MenuButton>
      <MenuItems>
            <MenuItem class="item">
                <button @click="changeQuantityPerPage(10)">10</button>
            </MenuItem>
            <MenuItem class="item">
                <button @click="changeQuantityPerPage(20)">20</button>
            </MenuItem>
            <MenuItem class="item">
                <button @click="changeQuantityPerPage(25)">25</button>
            </MenuItem>
      </MenuItems>
    </Menu>
    </div>

</template>
<script setup>
    import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'

    const emit = defineEmits(['changeQuantityPerPage'])

    const changeQuantityPerPage = (quantity) => {
        emit('changeQuantityPerPage', quantity)
    }
</script>

<style scoped>
.container-menu {
    z-index: 4;
    position: absolute;
    background-color: rgba(55, 55, 55, 0.7);
    color: white;
    border: .12rem solid rgba(0, 0, 0, 0.171);
    padding: .3rem;
    border-radius: .3rem;
    font-family: "Ancizar-regular", Helvetica, Arial;
}
.item {
    display: flex;
    background-color: rgb(220, 220, 220);
    border: .1rem solid rgba(0, 0, 0, 0.171);
    justify-content: center;
    width: 100%;
    margin-bottom: .1rem;
    border-radius: .3rem;
    color:black;

}

.item:hover {
    background-color: rgb(100, 120, 20);

}
</style>